// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qqU-","root_toggler":"styles_root_toggler__JLcrN","root_separator":"styles_root_separator__2es6b"};